export const AuthLogoutCallbackPage: React.FunctionComponent = () => {
	return null;
};
